<template>
  <div>
    <b-table
      ref="refCustomerTransactionsTable"
      :items="fetchCustomerTransactions"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
      :current-page="currentPage"
      :per-page="perPage"
    >

      <template #cell(id)="data">
        {{ data.item.id }}
      </template>

      <template #cell(paid_amount)="data">
        <span class="text-nowrap">
          {{ data.item.paid_amount }}
        </span>
      </template>

      <template #cell(grand_total_price)="data">
        <span class="text-nowrap">
          {{ data.item.grand_total_price }}
        </span>
      </template>

      <template #cell(wallet_deducted_price)="data">
        <span class="text-nowrap">
          {{ data.item.wallet_deducted_price }}
        </span>
      </template>

      <template #cell(subscription_deducted_price)="data">
        <span class="text-nowrap">
          {{ data.item.subscription_deducted_price }}
        </span>
      </template>

      <template #cell(created_at)="data">
        <span class="text-nowrap">
          {{ data.item.created_at }}
        </span>
      </template>

      <template #cell(payment_date)="data">
        <span class="text-nowrap">
          {{ data.item.paid_date }}
        </span>
      </template>

      <template #cell(type)="data">
        <span class="text-nowrap">
          {{ data.item.type }}
        </span>
      </template>

      <template #cell(invited_by)="data">
        <span
          v-if="data.item.invited_by"
          class="text-nowrap"
        >
          {{ data.item.invited_by.first_name }} {{ data.item.invited_by.last_name }}
        </span>
        <span
          v-else
          class="text-nowrap"
        >
          -
        </span>
      </template>

      <template #cell(payment_method)="data">
        <span
          v-if="data.item.payment_method"
          class="text-nowrap"
        >
          {{ data.item.payment_method.name }}
        </span>
        <span
          v-else
          class="text-nowrap"
        >
          <span v-if="data.item.type === 'INVITATION'">-</span>
          <span v-else>Subscription</span>
        </span>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="12"
          sm="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>
      </b-row>
      <b-row>

        <b-col
          cols="12"
          sm="6"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          md="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalCustomerTransactions"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import {
  BRow,
  BCol,
  // BButton,
  BTable,
  VBToggle,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useCustomerTransactions from './useCustomerTransactions'

export default {
  components: {
    BRow,
    BCol,
    // BButton,
    BTable,
    BPagination,
    vSelect,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {

    const {
      fetchCustomerTransactions,
      tableColumns,
      perPage,
      currentPage,
      totalCustomerTransactions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCustomerTransactionsTable,
      id,

      refetchData,
    } = useCustomerTransactions()

    onMounted(() => {
      id.value = props.customerId
    })

    return {
      fetchCustomerTransactions,
      tableColumns,
      perPage,
      currentPage,
      totalCustomerTransactions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCustomerTransactionsTable,
      id,
      refetchData,
    }
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
